module.exports = __webpack_public_path__ + "static/media/testimonials3.9406c47f.png";